import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface PanelProps {
  readonly title?: ReactNode;
  /** Right-aligned controls in the header row. */
  readonly actions?: ReactNode;
  readonly children: ReactNode;
  readonly className?: string;
  /** Drops the inner padding, for panels whose child is a full-bleed list. */
  readonly flush?: boolean;
}

/** The standard bordered surface. Every screen is built out of these. */
export function Panel({ title, actions, children, className, flush = false }: PanelProps) {
  return (
    <section className={cx('rounded-xl border border-line bg-base', className)}>
      {(title !== undefined || actions !== undefined) && (
        <header className="flex items-center justify-between gap-3 border-b border-line px-4 py-2.5">
          <h2 className="fs-13 font-semibold text-ink">{title}</h2>
          {actions !== undefined && <div className="flex items-center gap-2">{actions}</div>}
        </header>
      )}
      <div className={flush ? undefined : 'p-4'}>{children}</div>
    </section>
  );
}
